import _ from "lodash";
import React from "react";
import isEqual from 'react-fast-compare';
import { StyleSheet } from 'react-native';
import { ThemedSelectStyles } from 'styles/components/atoms/ThemedSelect';
import SelectMulti from 'theme/SelectMulti';
import Text from "theme/Text";
import i18n from "utils/i18n";

const ThemedSelectMulti = ({ style = {}, options = {}, selected, select, placeholder, disabled = false, label, caption, multiSelect = false, testID = null }) => {
	
	if( typeof placeholder === 'undefined' ) {
		placeholder = i18n.t('form.select.placeholder')
	}
	
	const onSelect = ( values ) => {
		if( _.isFunction( select ) ) {
			select( values );
		}
	}
	
	const selectStyle = [
		ThemedSelectStyles.select,
		style,
	]
	
	return (
		<SelectMulti
			style={ selectStyle }
			label={ label ? evaProps => {
				return <Text {...evaProps}>{label}</Text>;
			} : null }
			caption={ caption ? evaProps => {
				return <Text {...evaProps}>{caption}</Text>;
			} : null }
			placeholder={ placeholder }
			multiSelect={ multiSelect }
			disabled={ disabled }
			selected={ selected }
			onSelect={ onSelect.bind( this ) }
			data={ options }
		/>
	)
}

const styles = StyleSheet.create({
	selectItem: {
		flex: 1,
	}
});

export default React.memo( ThemedSelectMulti, isEqual );
